/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendConfirmationReferralRequest
 */
export interface MailBankSendConfirmationReferralRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankSendConfirmationReferralRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof MailBankSendConfirmationReferralRequest
     */
    courierId?: string;
}

/**
 * Check if a given object implements the MailBankSendConfirmationReferralRequest interface.
 */
export function instanceOfMailBankSendConfirmationReferralRequest(value: object): value is MailBankSendConfirmationReferralRequest {
    return true;
}

export function MailBankSendConfirmationReferralRequestFromJSON(json: any): MailBankSendConfirmationReferralRequest {
    return MailBankSendConfirmationReferralRequestFromJSONTyped(json, false);
}

export function MailBankSendConfirmationReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendConfirmationReferralRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function MailBankSendConfirmationReferralRequestToJSON(json: any): MailBankSendConfirmationReferralRequest {
    return MailBankSendConfirmationReferralRequestToJSONTyped(json, false);
}

export function MailBankSendConfirmationReferralRequestToJSONTyped(value?: MailBankSendConfirmationReferralRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'courierId': value['courierId'],
    };
}

